/**
 * External dependencies.
 */
import React, { useState } from 'react';
import cx from 'classnames';

import './styles/accordion.scss';
import LangA from '@i18n/LangA';
import CloudflareImage from '../cloudflare-image/CloudflareImage';
import LangButton from '../../i18n/LangButton';

const Accordion = ({ items, hasImage, additionalClass, customColor = false }) => {
  const [activeId, setActiveId] = useState(items && items[0] ? [items[0].id] : []);

  const toggleActive = (id) => {
    const idExists = activeId.includes(id);
    if (idExists) {
      setActiveId(activeId.filter((existingId) => existingId !== id));
    } else {
      setActiveId([...activeId, id]);
    }
  };

  return (
    <div className={cx('accordion', additionalClass)} data-aos="fade-up" data-aos-delay="100">
      {items &&
        items.map(
          (item) =>
            item.id && (
              <div
                key={item.id}
                style={{ background: hasImage && activeId.includes(item.id) && !customColor && '#EDF6FB' }}
                className={cx('accordion__section', { 'is-active': activeId.includes(item.id) })}
              >
                <div className="accordion__head">
                  <button
                    style={{
                      background: !customColor && hasImage && (activeId.includes(item.id) ? '#EDF6FB' : '#fff'),
                    }}
                    type="button"
                    className={cx('accordion__trigger', activeId.filter((existingId) => existingId !== item.id) ? 'isActive' : '')}
                    onClick={() => toggleActive(item.id)}
                  >
                    {hasImage &&
                      (activeId.includes(item.id) && item.activeIcon ? (
                        <CloudflareImage src={item.activeIcon} alt="" width="31" height="31" />
                      ) : (
                        <CloudflareImage src={item.inactiveIcon} alt="" width="31" height="31" />
                      ))}
                    {item.isHeading ? <h3 className="h4">{item.title}</h3> : item.title}

                    <span className="accordion__icon" />
                  </button>
                </div>

                <div className="accordion__body">
                  <div className="accordion__content">
                    {item.text && <p>{item.text}</p>}
                    {item.additionalContent && item.additionalContent}
                    {item.list && (
                      <ul className="accordion__content--list">
                        {item.list.map((item, idx) => (
                          <li key={idx} className="list_item">
                            {item.listAnswer}
                          </li>
                        ))}
                      </ul>
                    )}

                    {item.additionalText && item.additionalText.map((oneAdditionalText) => <p>{oneAdditionalText}</p>)}
                    {item.link && (
                      <p>
                        {item.link.preText && <span>{item.link.preText}</span>}
                        <LangA href={item.link.url}>{item.link.text}</LangA>
                        {item.link.postText && <span>={item.link.postText}</span>}
                      </p>
                    )}
                    {item.cta && (
                      <LangButton modifier="btn--primary" to={item.cta} externalLink={true}>
                        {item.ctaText}
                      </LangButton>
                    )}
                  </div>
                </div>
              </div>
            )
        )}
    </div>
  );
};

export default Accordion;
